import Entity from '../../../../core/domain/entity';
import UniqueEntityID from '../../../../core/domain/unique_entity_id';

export enum GoalStatus {
  INITIAL = 'INITIAL',
  TERMINATED = 'TERMINATED',
}

export interface GoalProps {
  patientId: string;
  patientUserId?: string | undefined;
  description: string;
  status: GoalStatus;
  achieved: boolean;
  createdAt: Date;
  updatedAt: Date | undefined;
}

export class GoalId extends Entity<unknown> {
  private constructor(id?: UniqueEntityID) {
    super(null, id);
  }

  public static create(id?: UniqueEntityID): GoalId {
    return new GoalId(id);
  }
}

export class Goal extends Entity<GoalProps> {
  get goalId() {
    return GoalId.create(this.id);
  }

  get patientId() {
    return this.props.patientId;
  }

  get patientUserId(): string | undefined {
    return this.props.patientUserId;
  }

  get description() {
    return this.props.description;
  }

  set description(description: string) {
    this.props.description = description;
  }

  get status(): GoalStatus {
    return this.props.status;
  }

  set status(status: GoalStatus) {
    this.props.status = status;
  }

  get achieved(): boolean {
    return this.props.achieved;
  }

  set achieved(value: boolean) {
    this.props.achieved = value;
  }

  get createdAt() {
    return this.props.createdAt;
  }

  get updatedAt() {
    return this.props.updatedAt;
  }

  set updatedAt(value: Date | undefined) {
    this.props.updatedAt = value;
  }

  copyWith(props: GoalProps): Goal {
    return Goal.create(
      {
        ...this.props,
        ...props,
      },
      this.id,
    );
  }

  private constructor(props: GoalProps, id?: UniqueEntityID) {
    super(props, id);
  }

  public static create(props: GoalProps, id?: UniqueEntityID): Goal {
    return new Goal(props, id);
  }
}
